module.exports = __webpack_public_path__ + "media/images/edit_placeholder-cac0a48ff18bca73c09b62947191d2ed.svg";